import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

// Por defecto: el ultimo mes (del mismo dia del mes pasado a hoy; moment ajusta fin de mes: 31 mar -> 28 feb).
const getInitialState = () => {
  const today = moment();
  return {
    initialDate: today.clone().subtract(1, 'month').toISOString(),
    endDate: today.toISOString(),
    shippingCompany: '',
    shippingCode: '',
  };
};

const metricsSlice = createSlice({
  name: 'metricsUI',
  initialState: getInitialState(),
  reducers: {
    setMetricsInitialDate: (state, action) => {
      state.initialDate = action.payload;
    },
    setMetricsEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setMetricsShippingCompany: (state, action) => {
      state.shippingCompany = action.payload;
      // Al cambiar de paqueteria el servicio elegido ya no aplica.
      state.shippingCode = '';
    },
    setMetricsShippingCode: (state, action) => {
      state.shippingCode = action.payload;
    },
    resetMetricsFilters: () => getInitialState(),
  },
});

export const { setMetricsInitialDate, setMetricsEndDate, setMetricsShippingCompany, setMetricsShippingCode, resetMetricsFilters } = metricsSlice.actions;
const metricsReducer = metricsSlice.reducer;
export default metricsReducer;
